var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('span',{staticStyle:{"color":"rgb(170, 170, 170)"}},[_vm._v("Copyright © 2024 ClouGence,Inc."),_c('a',{staticStyle:{"color":"rgb(170, 170, 170)","margin-left":"10px"},attrs:{"href":"http://www.miit.gov.cn/","target":"_blank"}},[_vm._v("浙ICP备20007605号-1")])])])
}]

export { render, staticRenderFns }